
angular.module('Services')
    .factory('AddressBook', function ($http, $rootScope, Error, Request) {
        return {
            getBook: function(callback) {
                Request.get({
                    url: ApiURLs.address.list,
                    successCallback: callback,
                    errorCallback: callback
                });
            },
            addToBook: function(data, callback, errCallback) {
                Request.post({
                    url: ApiURLs.address.list,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: errCallback
                }, data);
            },
            getAddress: function(id, callback) {
                Request.get({
                    url: ApiURLs.address.list + id + '/',
                    successCallback: callback,
                    errorCallback: callback
                });
            },
            deleteAddress: function(ids, callback) {
                Request.post({
                    url: ApiURLs.address.delete,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: callback
                }, ids);
            }
        }
    });


// WEBPACK FOOTER //
// ./js/services/addresses.js